module.exports = __webpack_public_path__ + "img/59.053aaf0c.jpg";